import React, {useRef} from "react";
import { connect } from "react-redux";
import {injectIntl} from "react-intl";

import IconButton from "@mui/material/IconButton";
import SvgIcon from "@mui/material/SvgIcon";

import {LookExitIcon} from "../../common/icons";
import COLOR_THEMES from "../../../colorThemes";
import {setLookOverlayOpened} from "../../../actions/lookFunctions";
import {LOOK_OVERLAYS} from "../core/constants";
import {ROUTES} from "../../../routes";
import Analytics, {LOOK_JOURNEY_ANALYTIC_EVENTS} from "../../../analytics";
import {isIframe} from "../../../misc/helpers";

const LookExitButton = (props) => {

  const {activeTheme, intl, setLookOverlayOpened, isMobile, lookPageOpened, fabricatorData} = props;
  const anchorRef = useRef(null);

  const isLixil = isIframe() && fabricatorData.isLixil;
  if (!isLixil && !fabricatorData.websiteUrl) {
    return null
  }

  const exitButtonClick = () => {
    Analytics.sendClickEvent(LOOK_JOURNEY_ANALYTIC_EVENTS.lookExit);
    setLookOverlayOpened(LOOK_OVERLAYS.exit);
  }

  const onTop = lookPageOpened === ROUTES.rooms && isMobile;

  return (
    <div className={"look-exit" + (onTop ? " look-exit--on-top" : "")}
         ref={anchorRef}>
      <IconButton aria-label={intl.formatMessage({id: "iconButton.exit"})}
                  className="look-icon look-icon--white2 look-exit__button"
                  // disabled={realDisabled}
                  onClick={exitButtonClick}>
        <SvgIcon>
          <LookExitIcon color={COLOR_THEMES[activeTheme].primary} />
        </SvgIcon>
      </IconButton>
    </div>
  )
};

const mapStateToProps = (store) => {
  const {activeTheme, isMobile} = store.serverState;
  const {lookPageOpened} = store.lookState;
  const fabricatorData = store.fabricatorState;

  return {
    activeTheme,
    isMobile,
    lookPageOpened,
    fabricatorData,
  };
};

const mapDispatchToProps = {
  setLookOverlayOpened,
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(LookExitButton)
)
